import React from "react";
import Page from "components/common/page/Page.component";
import AnimatedContainer from "containers/gis/animated/Animated.container";

const AnimatedMapPage = (props) => {
    return (
        <Page title="Mappa storica animata - GIS">
            <AnimatedContainer {...props} />
        </Page>
    );
};

export default AnimatedMapPage;
